<template>
    <div class="auth-info" :class="{ 'px30': $store.state.loginActiveStep === 'card' }">
        <h2
            class="page-title text-24 text-text mb-7 tracking-tight leading-tight main-page-title text-left auth-info-txt">
            <span class="text-primary">
                {{ $t("Authorize") }}
            </span>
            <span class="text-secondary">{{ $t("us to round up your purchases") }}</span>
        </h2>
        <p class="text-text tracking-normal leading-7 mb-12 page-description-top page-subtitle text-left">
            {{
                    $t(
                        "We need a little more information to authorize RoundUps. Right now, you're giving your monthly minimum.",
                    )
            }}
        </p>
        <div v-if="!$getState('corporation')['is']" class="table mx-auto mb-10 aut-info__icon" style='width:100%;'>
            <AuthorizeInfoIcon />
        </div>
        <p class="text-text tracking-normal leading-7 mb-12 page-description-bottom page-subtitle text-left">
            {{
                    $t(
                        "We’ve partnered with Plaid (a Visa Company) to make this process secure and protect your privacy.",
                    )
            }}
        </p>
        <div class="table mx-auto active-button">
            <Button type="dynamic" :click-handler="goToCardVerificationInfo" :text="$t('Continue')"
                classes="btn-dynamic mb-7 btn-custom"></Button>
            <!--            <button-->
            <!--                v-ripple-->
            <!--                class="btn-link table mx-auto text-16 font-bold tracking-tight text-text opacity-30"-->
            <!--                type="button"-->
            <!--                @click="skip"-->
            <!--            >-->
            <!--                {{ $t("Skip") }}-->
            <!--            </button>-->
        </div>
    </div>
</template>

<script>
import AuthorizeInfoIcon from "../Icons/AuthorizeInfoIcon";
import Button from "../UI/Button";
import mixins from "../../config/mixins";
export default {
    name: "AuthorizeInfo",
    components: { Button, AuthorizeInfoIcon },
    mixins: [mixins.plaid],

    data: function () {
        return {
            locale: this.$i18n.locale,
            // plaidData: null,
        };
    },

    methods: {
        goToCardVerificationInfo: function () {
            window.scrollTo(0, 0)
            this.$emit("goNextCardProcess", "provide");
        },
        // skip: function() {
        //     this.$setState("loginShowOperationTitle", false);
        //     this.$setState("userUpdate", { pr_bank: true, pr_card: true, pr_npo: true });
        //     this.$router.push("/dashboard");
        // },
    },
};
</script>
